import { createActions } from 'redux-actions';
import { KEYWORDS, DAYINDEX } from '../actionTypes';

export default createActions({
  [KEYWORDS]: (state) => {
    return state;
  },
  [DAYINDEX]: (state) => {
    return state;
  }
});
